var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info (3) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.125C10.3371 4.125 4.125 10.3371 4.125 18C4.125 25.6629 10.3371 31.875 18 31.875C25.6629 31.875 31.875 25.6629 31.875 18C31.875 10.3371 25.6629 4.125 18 4.125ZM1.875 18C1.875 9.09441 9.09441 1.875 18 1.875C26.9056 1.875 34.125 9.09441 34.125 18C34.125 26.9056 26.9056 34.125 18 34.125C9.09441 34.125 1.875 26.9056 1.875 18Z",
    fill: "#3683f7",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 25.625C18.6213 25.625 19.125 25.1213 19.125 24.5V16.5C19.125 15.8787 18.6213 15.375 18 15.375C17.3787 15.375 16.875 15.8787 16.875 16.5V24.5C16.875 25.1213 17.3787 25.625 18 25.625Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12C19.5 11.1716 18.8284 10.5 18 10.5C17.1715 10.5 16.5 11.1716 16.5 12C16.5 12.8284 17.1715 13.5 18 13.5C18.8284 13.5 19.5 12.8284 19.5 12Z",
    fill: "white",
    fillOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.05d40b70f1bc6760c85a1e40d894e8a5.svg";
export { ForwardRef as ReactComponent };